export default __webpack_public_path__ + "static/image3-c9401813c0bd32bcd27253bbac98f3e3.jpeg";